function getPoints() {
  let points = JSON.parse(localStorage.getItem('points'))
  if (points === null) {
    setPoints(0)
    points = 0
  }
  return points
}

function setPoints(points) {
  window.localStorage.setItem('points', JSON.stringify(points))
}

function getSpeed() {
  let speed = JSON.parse(localStorage.getItem('speed'))
  if (speed === null) {
    setSpeed(1000)
    speed = 1000
  }
  return speed
}

function setSpeed(speed) {
  window.localStorage.setItem('speed', JSON.stringify(speed))
}

function getStatistics(name = 'statistics') {
  let statistics
  try {
    statistics = JSON.parse(localStorage.getItem(name))
    if (statistics === null) {
      resetStatistics(name)
    }
  } catch {
    resetStatistics(name)
    statistics = {
      gamesPlayed: 0,
      gamesWon: 0,
      gamesLost: 0,
      gamesTied: 0
    }
  }

  return statistics
}

function updateStatistics(stats) {
  const name = 'statistics'
  window.localStorage.setItem(name, JSON.stringify(stats))
}

function resetStatistics() {
  const name = 'statistics'
  const statistics = {
    gamesPlayed: 0,
    gamesWon: 0,
    gamesLost: 0,
    gamesTied: 0
  }

  window.localStorage.setItem(name, JSON.stringify(statistics))
}

function getScores() {
  let scores = JSON.parse(localStorage.getItem('scores'))
  if (scores === null) {
    scores = {
      playerHand: 0,
      computerHand: 0,
    }
    updateScores(scores)
  }
  return scores
}

function updateScores(scores) {
  const name = 'scores'
  console.log('scores', scores)
  window.localStorage.setItem(name, JSON.stringify(scores))
}

function resetScores() {
  const name = 'scores'
  const scores = {
    playerHand: 0,
    computerHand: 0,
  }

  window.localStorage.setItem(name, JSON.stringify(scores))
}

export {
  getStatistics,
  updateStatistics,
  resetStatistics,
  getScores,
  updateScores,
  resetScores,
  getPoints,
  setPoints,
  getSpeed,
  setSpeed,
}
